import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { FavouritesShare } from '../../../molecules/favourites-share/js/favourites-share';
import { FavouritesAction } from '../../../molecules/favourites-action/js/favourites-action';

const classes = {
	statePopupVisible: "state-favourite-popup--visible",
	statePopupClose: "state-favourite-popup--close",
	stateCountMax: "state-textarea-count-max",
	stateLoadingVisible: "state-loading-wrapper--shown",
	stateValMsgVisible: "state-field-validation-error--visible",
	statePromptBoxVisible: "state-m-prompt-box--hidden",

	currentTitle: 'js-m-favourites-entry-table__heading',
	listContainer: 'js-o-favourites-overview__filter',
	entryContainer: "js-o-favourites-overview-entry",

	favouritesFilterClose: 'js-o-favourites-overview__filter-closer',
	stateFavouritesFilterShow: 'state-o-favourites-overview__filter--open',

	dynamicContainer: "js-m-favourites-overview-dynamic-container",

	noScrollingBar: "no-scrolling--without-scrollbar",
	listItem: "js-m-favourites-list-item",
	entryItem: "js-m-favourites-entry-item",
	actionItem: "js-m-tooltip-actions__list-item",
	addListItem: "js-m-favourites-list__add-item",

	loadingIndicator: "m-favourite-button__loading-wrapper",

	promptSharedSuccess: "js-prompt-shared-success",
	promptSharedFailure: "js-prompt-shared-failure"

};

const popupClasses = {
	popupBox: "js-m-modal-actions",
	textareaBox: "js-m-modal-actions__textarea"
}

const actions = {
	addList: "AddList",
	editList: "EditList",
	deleteList: "DeleteList",
	copyList: "CopyList",
	shareList: "ShareList",

	editEntry: "EditEntry",
	copyEntry: "CopyEntry",
	moveEntry: "MoveEntry",
	deleteEntry: "DeleteEntry"
};

const params = {
	sharedSuccess: "sharedsuccess",
	listId: "listid",
};

@createModule('FavouritesOverview')
/**
 * favourites-overview module
 */
export class FavouritesOverview extends TerrificSpec {
	$ctx: JQuery;
	$currentTitle: JQuery;
	$favouritesFilter: JQuery;
	$favouritesFilterClose: JQuery;

	$dynamicContainer: JQuery;
	$listContainer: JQuery;
	$entryContainer: JQuery;

	$loadingIndicator: JQuery;

	actionViewEndpoint: string;
	contentType: string;

	favorShare: FavouritesShare;
	favorAction: FavouritesAction;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$currentTitle = $(`.${classes.currentTitle}`, this.$ctx);
		this.$favouritesFilter = $(`.${classes.listContainer}`, this.$ctx);
		this.$favouritesFilterClose = $(`.${classes.favouritesFilterClose}`, this.$ctx);

		this.actionViewEndpoint = this.$ctx.data("action-view-endpoint");
		this.contentType =  this.$ctx.data("content-type");

		this.favorShare = new FavouritesShare();
		this.favorAction = new FavouritesAction();

		this.showFavouritesFilter();
		this.hideFavouritesFilter();

		this.$dynamicContainer = this.$ctx.find(`.${classes.dynamicContainer}`);
		this.$listContainer = this.$ctx.find(`.${classes.listContainer}`);
		this.$entryContainer = this.$ctx.find(`.${classes.entryContainer}`);

		this.$loadingIndicator = this.$ctx.find(`.${classes.loadingIndicator}`);

		this.$ctx.find(`.${classes.addListItem}`).on("click", () => {
			this.getActionPartialView(actions.addList, 0);
		});

		this.updateUrl();

		this.$listContainer.find(`.${classes.actionItem}`).on("click", (ev: any) => {
			const $action = $(ev.currentTarget);

			const actionType = $action.data("action-name");
			const listId = $action.data("item-id");

			this.getActionPartialView(actionType, listId);

		});

		this.$entryContainer.find(`.${classes.actionItem}`).on("click", (ev: any) => {
			const $action = $(ev.currentTarget);

			const actionType = $action.data("action-name");
			const entryId = $action.data("item-id");

			this.getActionPartialView(actionType, entryId);
		});

		resolve();
	}

	getActionPartialView(actionType: string, id: number) {
		const url = window.location.pathname;
		this.showLoadingIndicator();

		$.ajax({
			type: 'post',
			url: this.actionViewEndpoint,
			dataType: 'html',
			data:
			{
				actionType: actionType,
				id: id,
				currentUrl: url
			},
			success: (response: any) => {
				if (response.length > 2) {

					this.$dynamicContainer.append(response);
					const $popup = this.$dynamicContainer.children();
					this.favorAction.displayPopup($popup);

					if (actionType == actions.shareList) {
						this.favorShare.rebindEmailViewEvents($popup);
						this.favorShare.bindEmailSubmitEvent($popup, this.contentType);
						this.favorShare.bindClipboardEvents($popup, this.contentType);

					} else {
						this.favorAction.rebindCommonViewEvents($popup);
						this.favorAction.bindSubmitEvent($popup, this.contentType);
						this.prefillTextareaBox();

					}
				}

			},
			complete: () => {
				this.hideLoadingIndicator();
			},
			error: (xhr: any, status: string, error: string) => {
				console.log(`get action-view error, action type: ${actionType}, ${xhr.status}, ${xhr.statusText}, ${error}`);
			}
		});
	}

	prefillTextareaBox() {

		const $textareaBox = this.$dynamicContainer.find(`.${popupClasses.textareaBox}`);

		if ($textareaBox.length > 0) {
			const prefillTxt = $textareaBox.attr("value");

			if (prefillTxt.length > 0) {
				$textareaBox.val(prefillTxt);

				$textareaBox.focus();

				this.favorAction.countTextarea($textareaBox);
			}
		}
	}

	showLoadingIndicator() {
		this.$loadingIndicator.addClass(classes.stateLoadingVisible);
	}

	hideLoadingIndicator() {
		this.$loadingIndicator.removeClass(classes.stateLoadingVisible);
	}

	showFavouritesFilter() {
		this.$currentTitle.on('click', () => {
			this.$favouritesFilter.addClass(classes.stateFavouritesFilterShow);
		})
	}

	hideFavouritesFilter() {
		this.$favouritesFilterClose.on('click', () => {
			this.$favouritesFilter.removeClass(classes.stateFavouritesFilterShow);
		})
	}

	updateUrl() {
		const currentQuery = window.location.search.substr(1).toLocaleLowerCase();

		if (currentQuery.indexOf(params.listId) > -1) {
			const paramArr = currentQuery.split("&");
			let query = "";
			paramArr.forEach((value: string, index: number, array: string[]) => {
				if (value.indexOf(params.listId) > -1) {
					query = value;
				}
			});
			query = `?${query}`;

			history.pushState(null, null, query);
		} else {
			history.pushState(null, null, document.location.origin + document.location.pathname);
		}
	}

	stop() { }
}
